<template>
  <div class="fts-text-truncate" :style="cssVars">
    <div
      class="text-truncate__content"
      :class="{'text-truncate__content--collapse': isCollapse}"
      ref="text-truncate-content"
    >
      {{ value }}
    </div>

    <slot
      name="action"
      :setCollapse="setCollapse"
      :isCollapse="isCollapse"
      v-if="actionVisible"
    >
      <div class="fts-link-default text-truncate__action" @click="setCollapse">
        show {{ isCollapse ? 'more' : 'less' }}
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    fontSize: {
      type: String,
      default: '0.875rem'
    },
    lineHeight: {
      type: String,
      default: '1.25rem'
    },
    lineClamp: {
      type: Number,
      default: 4
    },
    value: String
  },
  data: () => ({
    resizeObserver: null,
    isCollapse: true,
    actionVisible: false,
  }),
  methods: {
    setCollapse() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.$nextTick(() => {
          const el = this.$refs['text-truncate-content'];
          if (!(el.scrollHeight > el.offsetHeight)) {
            this.actionVisible = false;
          }
        });
      }
    }
  },
  computed: {
    cssVars() {
      return {
        '--text-truncate-font-size': this.fontSize,
        '--text-truncate-line-height': this.lineHeight,
        '--text-truncate-line-clamp': this.lineClamp
      }
    }
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(_.debounce((entries) => {
      try {
        const entry = entries.find(x => x.target === this.$refs['text-truncate-content']);
        if (this.isCollapse) {
          if (entry.target.scrollHeight > entry.target.offsetHeight) {
            this.actionVisible = true;
          } else {
            this.actionVisible = false;
          }
        }
      } catch(err) {
        console.warn("[DOMException]:ResizeObserver", err);
      }
    }, 150));
    this.resizeObserver.observe(this.$refs['text-truncate-content']);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.$refs['text-truncate-content'] && this.resizeObserver.unobserve(this.$refs['text-truncate-content']);
      this.resizeObserver.disconnect();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.text-truncate__content {
  font-size: var(--text-truncate-font-size);
  line-height: var(--text-truncate-line-height);
  &.text-truncate__content--collapse {
    @include text-line-clamp(
      $fontSize: var(--text-truncate-font-size),
      $lineHeight: var(--text-truncate-line-height),
      $lineClamp: var(--text-truncate-line-clamp)
    );
  }
}
.text-truncate__action {
  display: inline-flex;
  margin-top: 0.5rem;
  font-size: var(--text-truncate-font-size);
  text-decoration: underline;
}
</style>